import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const createReasonInitialValue = {
  description: "",
  type: 1,
};

export const createReasonValidationSchema = Yup.object({
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  type: Yup.number().oneOf([1, 2]),
});

export type CreateReasonValues = typeof createReasonInitialValue;
